import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GdoProductRoutingModule } from './gdo-product-routing.module';
import { GdoProductContainerComponent } from './gdo-product-container/gdo-product-container.component';
import { GdoProductComponentsComponent } from './gdo-product-components/gdo-product-components.component';
import { GdoProductCardComponent } from './gdo-product-components/gdo-product-card/gdo-product-card.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [
  GdoProductContainerComponent,
  GdoProductComponentsComponent,
  GdoProductCardComponent
],

  imports: [
    CommonModule,
    MatGridListModule,
    MatButtonModule,
    GdoProductRoutingModule,
  ],
  exports:[
  ]
})
export class GdoProductModule { }
